import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaterialTimepickerModule } from '../../../../widgets/material-timepicker';
import { NouisliderModule } from 'ng2-nouislider';
import moment from 'moment';
import { RTLDivDirectiveDirective } from '../../../../directives/rtldiv-directive.directive';
import { TranslatorService } from '../../../../services/translator_service';
import { ApiQuery } from '../../../../web-services/api/api.query';
import { ApiStore } from '../../../../web-services/api/api.store';
import { ResponsiveService } from '../../../../services/responsive.service';
import { ApiService } from '../../../../web-services/api/api.service';
import { TranslatePipe } from '@ngx-translate/core';
import { DatepickerCustom } from '../../../../widgets/datepicker-custom/datepicker-custom';

@Component({
  selector: 'app-add-collection-modal',
  imports: [TranslatePipe, RTLDivDirectiveDirective,CommonModule,FormsModule,ReactiveFormsModule,MatFormFieldModule
    ,MatInputModule,MatSelectModule,NgxMaterialTimepickerModule,DatepickerCustom,NouisliderModule],  
  templateUrl: './add-collection-modal.html',
  styleUrl: './add-collection-modal.scss',
})
export class AddCollectionModal {
  currentLang;
	translationsObj;
  isMobile: boolean;
  binSitesToDisplay:any =[];
  filteredBins:any =[];
  ElForm: FormGroup;
  showDatePicker: boolean = false;
  dateLbl:any = '';
  staticTheme = {
    container: {
    },
    dial: {
      dialBackgroundColor: '#28B365',
    },
    clockFace: {
      clockHandColor: '#28B365',
    }
  };
  
  selectedDates: any = {
		date: '',
		dateformat: ''
	};

  constructor(private translator: TranslatorService,private dialogRef: MatDialogRef<AddCollectionModal>, 
    private responsiveService: ResponsiveService,private apiQuery:ApiQuery,public fb: FormBuilder,
    private apiService:ApiService,private apiStore:ApiStore) {
      this.dialogRef.disableClose = true;
      this.translator.currentLangEmitter$
      .subscribe(async value=>{						
        this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
        this.currentLang = value;	
      });

      this.ElForm = this.fb.group({
        site: new FormControl('', Validators.required),
        binName: new FormControl('', Validators.required),
        binAddress: new FormControl('', Validators.required),
        collection_time: new FormControl('', Validators.required),
        //prePickup: new FormControl(0, Validators.required),
        //postPickup: new FormControl(0, Validators.required)
      });
  }

  ngOnInit() {   
    this.onResize();
    this.responsiveService.checkWidth();
    this.ElForm.controls['binAddress'].disable();

    this.apiQuery.sitesListData$.subscribe((sitesList) => {
			if(sitesList.length == 0) return;
			this.binSitesToDisplay = sitesList; 
    });

    this.ElForm.controls['site']?.valueChanges.subscribe((siteId) => {
      this.filteredBins = [];
      this.apiQuery.filteredBins$.subscribe({
        next: (bins) => {
          this.filteredBins = bins.filter(bin => bin['site_id'] == siteId);
        },
        error: (err) => {
        }
      });
    });

    this.ElForm.controls['binName']?.valueChanges.subscribe(binId => {
      const selectedBin = this.filteredBins.find(bin => bin.bin_id == binId);
      const address = selectedBin?.Bin_location.bin_address || '';
      this.ElForm.controls['binAddress']?.setValue(address);
    });
  }

  onResize() {
    this.responsiveService.getMobileStatus().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  closeModal = () => {
    this.dialogRef.close();
  }

  applyChanges = () => {
    if(!this.ElForm.valid){
      return;
    }
    let insertRequest = {
      collection_status:1,
      is_create_transmission_info:1,
      create_transmission_bin_id: this.ElForm.getRawValue()['binName'],
    };

    let collectionTime = moment(this.selectedDates.dateformat + ' ' + this.ElForm.getRawValue()['collection_time']).format("YYYY-MM-DD HH:mm:ss");
    insertRequest['create_transmission_time'] = collectionTime;
    this.apiService.insertCollectionParams(insertRequest).subscribe((v:any) => {
      let request = {
        site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
        start_date : sessionStorage.getItem("collectionsMinDate"),
        end_date : sessionStorage.getItem("collectionsMaxDate")
      }
      let removedCollectionsStatsRequest = {
        site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
        start_date : sessionStorage.getItem("collectionsMinDate"),
        end_date : sessionStorage.getItem("collectionsMaxDate")
      }
      this.apiStore.update({ allCollectionsStats: [] });
      this.apiStore.update({ collectionsStatsInCollections: [] });
      this.apiService.getfilteredBinsCollectionsStats(request,5,JSON.parse(sessionStorage.getItem("chosenSites")));
      this.apiService.RemovedSuspectedCollections(removedCollectionsStatsRequest);
      this.apiService.getUnApprovedAndDeletedSuspectedAsCollectionEvents(removedCollectionsStatsRequest);
    });
    this.closeModal();
  }

  onSelectDates = (selectDates: any) => {
		this.selectedDates.date = selectDates.date;
		this.selectedDates.dateformat = selectDates.dateformat;	
    setTimeout(() => {
			this.dateLbl = this.selectedDates.date;	
		}, 0);
	}

  
	showHideDatePicker = () => {
		this.showDatePicker = !this.showDatePicker;
		if(this.showDatePicker){
			if(this.currentLang == 'iw'){
        const container = document.querySelector('.datepicker-container');

				const right_chv = container.querySelector('.ngb-dp-arrow-prev');
				const right_btn = right_chv.querySelector('button');
				const right_span = right_btn.querySelector('span');
				right_span.style.transform = 'rotate(45deg)';

				const left_chv = container.querySelector('.ngb-dp-arrow-next');
				const left_btn = left_chv.querySelector('button');
				const left_span = left_btn.querySelector('span');
				left_span.style.transform = 'rotate(-135deg)';
			}
		}
	}
}
